export default __webpack_public_path__ + "static/media/Meesho.e9bed08c.png";